var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"accent px-8",attrs:{"large":"","rounded":""},on:{"click":function($event){return _vm.sendScheduling()}}},[_vm._v(" إرسال الجدولة ")])}
var staticRenderFns = []

export { render, staticRenderFns }